import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router';
import { getGiftError } from './services';
import { getQueryParameter } from '@Utilities/services/queryParameters';
import './styles/giftError.scss';

function GiftError() {
  const { localized } = useOutletContext();
  const reason = getQueryParameter('reason');

  const { img, localizedKey } = getGiftError(reason);

  useEffect(() => {
    sessionStorage.removeItem('token');
  }, []);

  return (
    <div className='gift-error'>
      <img
        className='gift-error__img'
        src={img.src}
        alt={localized[img.alt] || ''}
      />
      <h1 className='gift-error__heading'>
        {localized[localizedKey.title] || ''}
      </h1>
      <p className='gift-error__description'>
        {localized[localizedKey.description] || ''}
      </p>
    </div>
  );
}

export default GiftError;
